import React, { useEffect } from "react";
import { Form, Space } from "antd";
import { FileImageOutlined } from "@ant-design/icons";
import { captureException } from "@sentry/react";
import useHttpClient from "/src/hooks/useHttpClient";
import { EMPTY_OBJECT } from "/src/constants";
import FileInput from "./FileInput";
import Card from "/src/components/Card";

function DocsForm({ data = EMPTY_OBJECT, disabled = false }) {
  const [form] = Form.useForm();
  const httpClient = useHttpClient();

  useEffect(() => {
    form.setFieldsValue(deserialize());
  }, [data]);

  function serializeForm() {
    const docs = form.getFieldsValue();
    return { docs };
  }

  function deserialize() {
    const { docs } = data;
    return docs;
  }
  function handleSubmit() {
    httpClient.put("/users/me/docs", serializeForm()).catch(captureException);
  }

  return (
    <Card title="ارسال مدارک" Icon={FileImageOutlined} actions={null}>
      <Form
        className="mt-4"
        layout="vertical"
        form={form}
        initialValues={{ layout: "vertical" }}
        onValuesChange={handleSubmit}
        disabled={disabled}
        variant='filled'
      >
        <Space size={20}>
          <Form.Item
            label="عکس روی کارت ملی"
            rules={[{ required: true, message: "این فیلد ضروری است" }]}
            name="nationalCardImage"
          >
            <FileInput />
          </Form.Item>
          <Form.Item
            label="عکس پشت کارت ملی"
            rules={[{ required: true, message: "این فیلد ضروری است" }]}
            name="nationalCardBackImage"
          >
            <FileInput />
          </Form.Item>
        </Space>
      </Form>
    </Card>
  );
}

export default DocsForm;
